module.exports = __webpack_public_path__ + "static/media/Huis-2-3.003ba275.jpg";